module.exports = __webpack_public_path__ + "img/6.f9c7af85.png";